import { installPlugin } from "./installPlugin.js";
import { uninstallPlugin, } from "./uninstallPlugin.js";
export {} from "./installPlugin.js";
export {} from "./uninstallPlugin.js";
export const pluginManagerActions = (client) => ({
    installPlugin: async (params) => installPlugin(client, params),
    uninstallPlugin: async (params) => uninstallPlugin(client, params),
});
//# sourceMappingURL=decorator.js.map